<!-- <!-- 电池包 -->
<template>
	<div class="carBg">
		<div class="batter">
			<div class="flex flex-direction">
				<div class="batterBox">
					<div class="point">
						<div class="inner flex flex-direction">
							<div class="title text-xsss">电池包ID：{{ batteryId }}</div>
							<div class="code text-xs padding-bottom-xs">最高温度：{{ batteryData.maximumMonomerTemperature }}</div>
							<div class="code text-xs padding-bottom-xs">最低温度：{{ batteryData.minimumMonomerTemperature }}</div>
							<div class="code text-xs padding-bottom-xs">平均温度：{{ batteryData.averageimumMonomerTemperature }}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="temp-volt">
				<p>当前温度：{{ atBattery.st }}°C</p>
				<p>当前电压：{{ atBattery.sv }}V</p>
			</div>
		</div>
		
		<!-- 电池列表，30个，然后轮播 -->
		<BatteryBagList @changeTem="changeTem" />
	</div>
</template>

<script>
import BatteryBagList from "./batteryList.vue";

export default {
	name: 'home',
	components: {
		BatteryBagList
	},
	props: {
		batteryData: {
			type: Object,
			default: () => { return {} }
		},
	},
    inject: ['batteryObj'],
    computed: {
        computedProperty() {
            return this.batteryObj()
        }
    },
	watch: {
        computedProperty(val) {
            this.batteryId = val.value
		    // this.init()
        },
		batteryData(newV) {
			this.batteryData = newV
			this.$set(this.batteryData)
		}
	},
	data() {
		return {
			currentIndex: 0, //当前选中
			batteryId: '',
			atBattery: {}
		}
	},
	methods: {
		changeTem(item) {
			// debugger
			this.atBattery = item
		},
		//子组件触发 修改父组件数据
		changeParentIndex(index) {
			this.currentIndex = index;
		},
	},
}
</script>
<style lang="scss" scoped>
	$green-text:#49FFF9;

	// 电池遍历
	$gutter-width: 13px;
	$array: (1, 2, 3, 4, 5, 6, 7, 8);

	.green-text {
		color: $green-text;
	}

	.carBg {
		position: relative;
		transform: translate(0, -12%);

		.batter {
			position: relative;
			width: 998px;
			height: 580px;
			background: url('~@/assets/images/batteryBag/batterybag.png');
			background-size: 100% 100%;

			.batterBox {
				// width:238px;
				// height:44px;
				margin-top: 100px;
				position: relative;
				font-size: 12px;

				.point {
					display: block;
					position: absolute;
					width: 500px;
					height: 314px;
					background: url('~@/assets/images/batteryBag/point.png');
					background-size: 100% 100%;
					bottom: 20%;
					left: 70%;
					z-index: 999;

					.inner {
						width: 328px;
						height: 164px;
						margin-left: 85px;
						box-sizing: border-box;
						padding-left: 60px;

						.title {
							// border-bottom: 1px solid #3DBCC1;
							// width: 80%;
							padding: 35px 0;
							white-space: nowrap;
						}
					}
				}
			}

			.temp-volt {
				position: absolute;
				width: 250px;
				height: 121px;
				font-size: 16px;
				background: url(~@/assets/images/energyMuseum/battery1.png) no-repeat;
				background-size: 100% 100%;
				bottom: -20px;
				display: flex;
				align-items: flex-start;
				justify-content: center;
				flex-direction: column;
				padding-left: 30px;
				> p {
					white-space: nowrap;
					padding: 10px 0;
				}
			}
		}

	}

	.point3 {
		background: #00BAB8;
		border-radius: 2px;
		font-size: 18px;
		font-weight: 500;
		padding: 8px 13px;
		display: inline;

		img {
			width: 16px;
			height: 16px;
			margin-left: 5px;
		}
	}

	.DS-font {
		font-family: 'DS-Digital-Bold'
	}

	.resetPage {
		position: absolute;
		top: -200px;

		.inner {
			max-width: 164px;
			height: 52px;
			background: linear-gradient(180deg, rgba(14, 134, 139, 0.88) 0%, rgba(0, 43, 41, 0.6) 100%);
			border: 1px solid #1A7683;
			padding: 0 34px;
		}

		img {
			width: 16px;
			height: 16px;
			margin-right: 5px;
			transform: rotate(180deg);
		}
	}
</style> -->